import config from '@project/config';

const charityOutreachBaseUrl = `${config.apiUrl}/charity_outreaches`;
const charityBaseUrl = `${config.apiUrl}/charities`;

export default {
  getCharityOutreachUrl: (id: string) => `${charityOutreachBaseUrl}/${id}`,
  getAllCharityOutreachesUrl: () => `${charityOutreachBaseUrl}`,
  getCharityUrl: (id: string) => `${charityBaseUrl}/${id}`,
};
